import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { GoogleRatingLink } from './components/GoogleRatingLink'
import { Icon } from '../../atoms'
import { GoogleRatingOutputDto, Maybe } from '../../../lib/graphql'

interface ClassNames {
  container?: string
  rating?: string
  iconStar?: string
  userRatingsTotal?: string
}

interface Props extends GoogleRatingOutputDto {
  className?: ClassNames
  inverseStarAndRating?: boolean
  small?: boolean
  placeId?: Maybe<string>
  isNabooRating?: boolean
}

export const Rating: React.FC<Props> = ({
  rating,
  userRatingsTotal,
  className,
  inverseStarAndRating,
  small,
  placeId,
  isNabooRating,
}) => {
  if (!rating || !userRatingsTotal) {
    return null
  }

  const RatingMessage = () =>
    isNabooRating ? (
      <FormattedMessage
        id='ui.GoogleRating.nabooRatings'
        defaultMessage='({userRatingsTotal} {userRatingsTotal, plural, one {évènement} other {évènements}})'
        values={{ userRatingsTotal }}
      />
    ) : (
      <FormattedMessage
        id='ui.GoogleRating.ratings'
        defaultMessage='({userRatingsTotal} avis)'
        values={{ userRatingsTotal }}
      />
    )

  return (
    <div
      className={clsx(s.container, className?.container, {
        [s.smallContainer]: small,
        [s.nabooRating]: isNabooRating,
      })}
    >
      {inverseStarAndRating ? (
        <>
          <div className={clsx(s.rating, className?.rating)}>{rating}</div>
          <Icon name='star' className={clsx(s.iconStar, className?.iconStar)} />
        </>
      ) : (
        <>
          <Icon name='star' className={clsx(s.iconStar, className?.iconStar)} />
          <div className={clsx(s.rating, className?.rating)}>{rating}</div>
        </>
      )}

      <div className={clsx(s.userRatingsTotal, className?.userRatingsTotal)}>
        {placeId ? (
          <GoogleRatingLink placeId={placeId}>
            <RatingMessage />
          </GoogleRatingLink>
        ) : (
          <RatingMessage />
        )}
      </div>
    </div>
  )
}
